/* istanbul ignore file */
import { connect } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { BreadcrumbWrapper } from '../components/Breadcrumb';
import { selectBreadcrumbData, selectBreadcrumbJSONLDSchema } from '../modules/selectors';
import type { BreadcrumbContainerDispatchProps, BreadcrumbContainerStateProps } from '../types';

export const mapStateToProps = (state: ReduxApplicationState): BreadcrumbContainerStateProps => ({
  JSONLDSchema: selectBreadcrumbJSONLDSchema(state),
  breadcrumbItems: selectBreadcrumbData(state),
});

export const mapDispatchToProps = (): BreadcrumbContainerDispatchProps => ({
  onLinkClick: ({ linkDepth, destinationUrl }) => {
    return sendGAEvent({
      event: 'custom_event',
      event_action: 'Link Click',
      event_category: 'Breadcrumb',
      event_label: `${linkDepth} Level(s) Up`,
      destination_URL: destinationUrl,
    });
  },
});

export const BreadcrumbContainer = connect(mapStateToProps, mapDispatchToProps)(BreadcrumbWrapper);
